<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card m-b-30">
                <div class="card-body">
                    <form #appointmentForm="ngForm" name="appointmentForm">

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card m-b-30">
                                    <div class="card-body">

                                        <!-- SEARCH PATIENT STARTS -->
                                        <form #appointmentForm="ngForm" [formGroup]="create_med_cate_form"
                                            name="appointmentForm">
                                            <div class="row">
                                                <div class="col-12">
                                                    <h6 class="text-center">SEARCH MEDICNE</h6>
                                                </div>
                                            </div><br>
                                            <div class="row">
                                                <div class="col-lg-2 col-md-2 "></div>
                                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                    <div class="text-dark">Select Category Name</div>
                                                    <select class="form-control select" formControlName="med_cate"
                                                        (change)="retriveSubcategory($event)">

                                                        <option *ngFor="let x of cate" [value]="x.med_cate_id">
                                                            {{ x.med_cate}}
                                                        </option>

                                                    </select>
                                                    <!-- <input type="text" formControlName="med_cate"
                                                        placeholder="Category Name" class="form-control select" /> -->
                                                    <!-- <select formControlName="med_cate" class="form-control select">
                                                        <option>Select Category</option>
                                                        <option></option>
                                                        <option></option>
                                                    </select> -->
                                                </div>
                                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                    <div class="text-dark">Select Sub Category Name</div>
                                                    <select class="form-control select" formControlName="med_sub_cate">
                                                        <option *ngFor="let x of subcate" [value]="x.med_sub_cate_id">
                                                            {{ x.med_sub_cate}}
                                                        </option>

                                                    </select>
                                                </div>

                                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                    <div class="text-dark">Enter Medicine Name</div>
                                                    <input type="text" formControlName="medicine" list="browsers"
                                                        name="browser" id="browser" (keyup)="medicinesFet($event)"
                                                        placeholder="MEDICINE NAME" class="form-control select">
                                                    <!-- <datalist id="browsers">
                                                        <option *ngFor="let x of medicineAuo" [value]="x.med_name">
                                                            {{ x.med_name}}
                                                        </option>
                                                    </datalist> -->
                                                </div>

                                                <div class="col-lg-1 col-md-1 "></div>

                                            </div>

                                            <br />


                                            <div class="row">
                                                <div class="col-12 text-center">
                                                    <button type="submit" name="find"
                                                        class="btn btn-primary text-white btn-rounded"
                                                        (click)="getMedicinerecords()">FIND
                                                        MEDICNE</button>&nbsp;&nbsp;
                                                    <!-- <button type="button" name="find"
                                                        class="btn btn-secondary text-white btn-rounded">Reset</button> -->
                                                </div>
                                            </div>

                                        </form> <br /> <br />

                                        <!-- <form class="example-form">
                                            <mat-form-field class="example-full-width" appearance="fill">
                                                <mat-label>Number</mat-label>
                                                <input type="text" placeholder="Pick one" aria-label="Number" matInput
                                                    [formControl]="myControl" [matAutocomplete]="auto">
                                                <mat-autocomplete #auto="matAutocomplete">
                                                    <mat-option *ngFor="let option of filteredOptions | async"
                                                        [value]="option">
                                                        {{option}}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </form> -->


                                        <!-- SEARCH PATIENT MEDICINE -->

                                        <div class="container-fluid" *ngIf="medicine?.length">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="card m-b-30">
                                                        <div class="card-body table-responsive">
                                                            <div class="col-md-12 detail-tbl">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" class="th-item"
                                                                                style="vertical-align: middle">CATEGORY
                                                                                NAME
                                                                            </th>
                                                                            <th scope="col" class="th-item"
                                                                                style="vertical-align: middle">SUB
                                                                                CATEGORY NAME
                                                                            </th>
                                                                            <th scope="col" class="th-item"
                                                                                style="vertical-align: middle">MEDICINE
                                                                                NAME
                                                                            </th>
                                                                            <th scope="col" class="th-item"
                                                                                style="vertical-align: middle">MEDICINE
                                                                                TYPE
                                                                            </th>
                                                                            <th scope="col" class="th-item"
                                                                                style="vertical-align: middle"> MEDICINE
                                                                                STRENGTH
                                                                            </th>
                                                                            <th scope="col" class="th-item">DELETE</th>
                                                                            <th scope="col" class="th-item">EDIT</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tr *ngFor="let p of medicine let i = index">
                                                                        <td
                                                                            class="font-size-15 text-color align-middle">
                                                                            {{ p?.med_cate}}
                                                                        </td>
                                                                        <td
                                                                            class="font-size-15 text-color align-middle">
                                                                            {{ p?.med_sub_cate}}
                                                                        </td>
                                                                        <td
                                                                            class="font-size-15 text-color align-middle">
                                                                            {{ p?.med_name}}
                                                                        </td>
                                                                        <td
                                                                            class="font-size-15 text-color align-middle">
                                                                            {{ p?.med_type}}
                                                                        </td>
                                                                        <td
                                                                            class="font-size-15 text-color align-middle">
                                                                            {{ p?.med_strength}}
                                                                        </td>
                                                                        <td class="align-middle">
                                                                            <div class="d-flex">
                                                                                <i class="fa fa-trash fa-2x"
                                                                                    (click)="onAccStatusChange(p)"></i>


                                                                            </div>
                                                                        </td>

                                                                        <td class="align-middle">
                                                                            <div class="d-flex">
                                                                                <i class="fa fa-pencil fa-2x"
                                                                                    (click)="showeditmedsubcate(p)"
                                                                                    id="showeditmedcate"></i>

                                                                                <!-- <button type="button"
                                                                                    class="btn btn-primary btn-model"
                                                                                    routerLink="/superadmin/pat-detail/{{ p.pid }}">
                                                                                    EDIT
                                                                                </button> -->
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tbody>
                                                                        <tr></tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>





                                        <!-- SEARCH PATIENT ENDS -->
                                    </div>

                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end container-->

<ng-template #showeditmedsubcateModal let-modal>

    <div class="container-fluid ">
        <div style="text-align:right;"> <br /><a data-dismiss="modal" href="javascript:void(0);" class="fa fa-close"
                (click)="modal.dismiss()" style="font-size:18px;color:red;"></a>
        </div>
        <h4>&nbsp;&nbsp;Edit Medicine&nbsp;&nbsp;</h4>
        <form [formGroup]="createmedicineform">



            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="text-dark">Select Category</div>
                    <select class="form-control select" (click)="retriveSubcategory($event)"
                        formControlName="med_cate_id">
                        <option value="med_cate_id">{{med_cate}}</option>
                        <option *ngFor="let x of cate" [value]="x.med_cate_id">
                            {{ x.med_cate}}
                        </option>
                    </select>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
            </div>

            <br /><br />
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="text-dark">Select Sub-Category</div>
                    <select class="form-control select" formControlName="med_sub_cate_id">
                        <option value="med_sub_cate_id">{{med_sub_cate}}</option>

                        <option *ngFor="let x of subcate" [value]="x.med_sub_cate_id">
                            {{ x.med_sub_cate}}
                        </option>
                    </select>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
            </div>

            <br /><br />
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="text-dark">Medicine Name:</div>
                    <input type="text" formControlName="med_name" placeholder="Medicine Name" [value]="med_name"
                        class="form-control select" />
                </div>
                <div *ngIf="createmedicineform.get('med_name').hasError('required')" class="invalid-feedback ml-1">
                    Medicine Name is <strong>required</strong>.
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
            </div>
            <br /><br />

            <div class="row">

                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="text-dark">Select Medicine Type:</div>
                    <select class="form-control select" formControlName="med_type">
                        <option [value]="med_type">{{med_type}}</option>
                        <option *ngFor="let x of med_type_" [value]="x">
                            {{x }}
                        </option>

                    </select>
                    <div *ngIf="createmedicineform.get('med_type').hasError('required')" class="invalid-feedback ml-1">
                        Medicine Type is <strong>required</strong>.
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>

            </div>
            <br /><br />





            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="text-dark">Enter Medicine Strength:</div>
                    <input type="text" formControlName="med_strength" placeholder="Strength" [value]="med_strength"
                        class="form-control select" />
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
            </div>

            <br /><br />



            <div class="row">
                <div class="col-12 text-center">
                    <button type="submit" (click)="createmedicine(med_id)" [disabled]="createmedicineform.invalid"
                        class="btn btn-primary text-white btn-rounded">UPDATE
                        MEDICINE</button>&nbsp;&nbsp;
                    <!-- <button type="button" name="find"
                            class="btn btn-secondary text-white btn-rounded">Reset</button> -->
                </div>
            </div>
            <br /><br />

        </form>

    </div>

</ng-template>
<!--end container-->